
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import TranslatedText from '@/TranslatedText';

interface RegisterFormFieldsProps {
  form: UseFormReturn<any>;
  userType: 'ahavexer' | 'customer';
}

export const RegisterFormFields: React.FC<RegisterFormFieldsProps> = ({
  form,
  userType,
}) => {
  return (
    <>
      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormItem>
            <FormLabel><TranslatedText text="Email" /></FormLabel>
            <FormControl>
              <Input placeholder="Enter your email" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      {userType === 'ahavexer' && <AhavexerFormFields form={form} />}
      
      <FormField
        control={form.control}
        name="password"
        render={({ field }) => (
          <FormItem>
            <FormLabel><TranslatedText text="Password" /></FormLabel>
            <FormControl>
              <Input type="password" placeholder="Enter your password" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="confirmPassword"
        render={({ field }) => (
          <FormItem>
            <FormLabel><TranslatedText text="Confirm Password" /></FormLabel>
            <FormControl>
              <Input type="password" placeholder="Confirm your password" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

interface AhavexerFormFieldsProps {
  form: UseFormReturn<any>;
}

export const AhavexerFormFields: React.FC<AhavexerFormFieldsProps> = ({
  form,
}) => {
  return (
    <>
      <FormField
        control={form.control}
        name="fullName"
        render={({ field }) => (
          <FormItem>
            <FormLabel><TranslatedText text="Full Name" /></FormLabel>
            <FormControl>
              <Input placeholder="Enter your full name" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="ahavexId"
        render={({ field }) => (
          <FormItem>
            <FormLabel><TranslatedText text="Ahavexer ID" /></FormLabel>
            <FormControl>
              <Input placeholder="Enter your Ahavexer ID" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="address"
        render={({ field }) => (
          <FormItem>
            <FormLabel><TranslatedText text="Address" /></FormLabel>
            <FormControl>
              <Input placeholder="Enter your address" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
